import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { Button } from '../../../components/Buttons';
import { Check } from '../../../components/Icon';
import { Dropdown } from '../../../components/Dropdown';

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class InputWithInitialValueComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      value: props.value || '',
    });
  }

  componentDidMount() {}

  render() {
    let isEmpty = !this.state.value && !this.props.value;

    return (
      <FormField  label={this.props.label}>
        {this.props.dropdown ? (
          this.renderDropdown()
        ) : (
          <Input className={this.props.classNameInput} value={this.state.value} onChange={this.onInputChange.bind(this)} name="value" />
        )}
        {this.props.onChange && this.state.value != this.props.value && !isEmpty ? (
          <Button className={this.props.className} small onClick={() => this.props.onChange(this.state.value)}>
            <Check />
          </Button>
        ) : null}
      </FormField>
    );
  }

  renderDropdown() {
    return (
      <>
        <Dropdown options={this.props.options} value={this.state.value} onChange={o => this.setState({ value: o.value })} />
      </>
    );
  }
}

InputWithInitialValueComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const InputWithInitialValue = compose(
  withConnect,
  withRouter,
)(InputWithInitialValueComp);
